import React from 'react';
import { useInView } from '@/hooks/useInView';

export const SafetySection = ({ t }) => {
  const [ref, isInView] = useInView();

  return (
    <section id="safety" className="py-20 bg-gray-900 text-white" data-testid="safety-section">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-testid="safety-title">{t.safety.title}</h2>
          <div className="w-20 h-1 bg-blue-500 mx-auto mb-4"></div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-testid="safety-subtitle">
            {t.safety.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.safety.principles.map((principle, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 hover:bg-white/20 transition-all duration-300"
              data-testid={`safety-principle-${index}`}
            >
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4">
                <span className="text-2xl font-bold">{index + 1}</span>
              </div>
              <h3 className="text-xl font-bold mb-3" data-testid={`safety-principle-title-${index}`}>{principle.title}</h3>
              <p className="text-gray-300" data-testid={`safety-principle-description-${index}`}>{principle.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
